module.exports = __webpack_public_path__ + "static/pr_performance_hero-446c6f386806982fea7ef9d408a102bb.jpg";